import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';

import { Footer } from './styles';
import { Space } from 'antd';

export function ModalFooter({ loading, onCancel, onOk, okText, cancelText, cancelColor, okColor, showOk, children }) {
  return (
    <Footer>
      <Space>
        <Button loading={loading} color={cancelColor} onClick={onCancel}>
          {cancelText}
        </Button>
        { showOk ? (
        <Button loading={loading} color={okColor} onClick={onOk}>
          {okText}
        </Button>
        ) : null}
      </Space>
    </Footer>
  );
}

ModalFooter.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.oneOf([PropTypes.any]),
  onCancel: PropTypes.oneOfType([PropTypes.func]),
  onOK: PropTypes.oneOf([PropTypes.func]),
  cancelText: PropTypes.oneOfType([PropTypes.any]),
  okText: PropTypes.oneOfType([PropTypes.any]),
  cancelColor: PropTypes.string,
  okColor: PropTypes.string,
  showOk: PropTypes.bool,
};

ModalFooter.defaultProps = {
  loading: false,
  children: null,
  cancelText: 'Cancel',
  okText: 'Save',
  cancelColor: 'clear',
  okColor: 'primary',
  showOk: true,
};
